import { jsx as _jsx } from "react/jsx-runtime";
import { employeeTids } from '../../constants/tids';
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
export const EmailField = ({ value, required, onValueChange, validationInfo }) => {
    return (_jsx(FieldWrapper, { label: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", children: _jsx(TrimmedInput, { removeAllSpace: true, width: 202, value: value, required: required, onValueChange: onValueChange, validationInfo: validationInfo, "data-tid": employeeTids.emailInput }) }));
};
